import { CssQuestionType } from '@webapp/common/components/survey-custom';

import type { SurveyQuestion } from '@webapp/survey/src/components/questions/lib';

import { MatrixLayout } from '../matrix-layout';

import { Group } from './group';

export const MatrixDropdown: VFC<SurveyQuestion> = ({ question }) => (
    <MatrixLayout cell={Group} className={CssQuestionType.MATRIX_DROPDOWN} question={question} />
);
MatrixDropdown.displayName = 'MatrixListDropdown';
